import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { studentsCreatePost } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postStudentsCreate = createAsyncThunk(
    'postStudentsCreate/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await studentsCreatePost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_GQ_ADMIN_STUDENT_CREATE_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postStudentsCreateSlice = createSlice({
    name: 'postStudentsCreate',
    initialState,
    extraReducers: {
        [postStudentsCreate.pending]: (state) => {
            state.loading = true;
        },
        [postStudentsCreate.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postStudentsCreate.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postStudentsCreateSelector = (state) => state.postStudentsCreate;
export const postStudentsCreateReducer = postStudentsCreateSlice.reducer;
